// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App'
import router from './router'
import VideoPlayer from 'vue-video-player'
import 'vue-video-player/src/custom-theme.css'
import 'video.js/dist/video-js.css'
import { Swipe, SwipeItem,Icon,Col, Row,Button,Image as VanImage ,Popup,Empty,Notify} from 'vant';
import 'vant/lib/index.css';

Vue.use(Swipe).use(SwipeItem).use(Icon).use(Col).use(Row).use(Button).use(VanImage).use(Popup).use(Empty).use(Notify);
Vue.use(VideoPlayer)
Vue.use(ElementUI);

router.beforeEach((to,from,next)=>{
  //跳转后从头开始
  document.body.scrollTop = 0;//chrome
  document.documentElement.scrollTop = 0;//firefox
  window.scrollY = 0;//safari

  //页面标题
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js